import React from 'react'
import { useSession } from 'next-auth/react'
import Layout from '@src/components/Layout'
import { ExhibitionList } from '@src/components/ExhibitionList'
import { WorkList } from '@src/components/WorkList'
import useRedirects from '../lib/useRedirects'

const TenantIndex = () => (
  <Layout>
    <ExhibitionList />
    <WorkList orphanWorksOnly />
  </Layout>
)

const Index: React.FC = () => {
  const { data: session, status: sessionStatus } = useSession()
  useRedirects(session, sessionStatus === 'loading')

  return (<TenantIndex />)
}

export default Index
